import React from 'react';
import styled from 'styled-components';

import Image from '../../../components/Image/Image';

const StyledImage = styled(Image)`
  width: 100%;
`;

/**
 * External wrapper for `components/Image`
 * @param {Object} props
 * @param {string} props.src
 * @param {string} [props.alt]
 * @param {string} [props.className]
 */
export const ContentImage = ({ src, alt = '', className }) =>
  src ? <StyledImage src={src} alt={alt} className={className} /> : null;

export default ContentImage;
